export default __webpack_public_path__ + "static/media/90t.40e6747b.jpg";